// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"c65626c4","836":"afcaeb6b","844":"95aea0b9"}[chunkId] + ".chunk.js";
};